/* @flow */
import UsersSmsInviteInstructionsPhone from './UsersSmsInviteInstructionsPhone';

export default UsersSmsInviteInstructionsPhone;
